<template>
  <div class="app-container">
    <wt-form-table :form.sync="form" @on-button-action="onButtonAction">
      <wt-form-table-list ref="lopperTableRef" slot="wtFormTableList" :form.sync="form" @on-button-action="onButtonAction">
        <template slot="garbageImg" slot-scope="data">
          <img class="table-img" v-if="data.row.garbageImg && data.row.garbageImg.length > 0" :src="imgUrl + data.row.garbageImg.split(',')[0]">
        </template>
        <template slot="proveImg" slot-scope="data">
          <img class="table-img" v-if="data.row.proveImg && data.row.proveImg.length > 0" :src="imgUrl + data.row.proveImg.split(',')[0]">
        </template>
        <template slot="garbageWeight" slot-scope="data">
          <span>{{ $wtUtil.transWeight(data.row.garbageWeight) }}</span>
        </template>
        <template slot="garbagePrice" slot-scope="data">
          <span>{{ $wtUtil.transMoney(data.row.garbagePrice) }}</span>
        </template>
        <template slot="garbageTotalPrice" slot-scope="data">
          <span>{{ $wtUtil.transMoney(data.row.garbageTotalPrice) }}</span>
        </template>
        <template slot="deliveryWay" slot-scope="data">
          <span v-if="data.row.deliveryWay*1 === 1">线下</span>
          <span v-if="data.row.deliveryWay*1 === 2">投递柜</span>
        </template>
       </wt-form-table-list>
    </wt-form-table>
  </div>
</template>

<script>
import request from '@/utils/request'
export default {
  data() {
    return {
      imgUrl: window.wtConst.FILE_SERVER_URL,
      form: { //  表单数据
        isFormLoading: false,
        formCode: 'MODULE_CUSTOMERDELIVERYGARBAGE',
        formComponent: {
          view: { type: 'component', componentName: 'CustomerDeliveryGarbageView', value: 'queryUserDeliveryGarbageDetailData', noRequest: true },
          list: { type: 'default', value: '/modules/userDeliveryGarbage/userDeliveryGarbageList' }
        },
        formInputsData: [{ name: '搜索用户', key: 'nickName', value: '', type: 'text' },
          { name: '社区', key: 'communityId', value: '', type: 'select', option: [] },
          { name: '交付时间', key: 'updateTimeRange', value: [], type: 'datetime' },
          { name: '用户类型', key: 'userType', value: 2, type: 'customAllFixed', display: 'more' },
          { name: '投递方式',
            key: 'deliveryWay',
            value: '',
            type: 'select',
            data: [{ label: '全部', value: '' },
              { label: '线下', value: 1 },
              { label: '投递柜', value: 2 }] },
          { name: '投递柜订单', key: 'onlineOrderId', value: '', type: 'text' },
          { name: '投递柜', key: 'onlineMachine', value: '', type: 'text' }],
        formButtonsData: [{
          name: '导出Excel',
          key: 'EXPORT',
          action: 'EXCEL',
          hidden: false,
          url: window.wtConst.BASE_API + '/modules/userDeliveryGarbage/userCustomerDeliveryGarbageListImport',
          fileName: '大客户垃圾投递',
          permission: 'EXPORT'
        }],
        formTableData: [
          { name: '用户姓名', key: 'name', type: 'text' },
          { name: '投递柜订单编号', key: 'onlineOrderId', type: 'text', minWidth: 110 },
          { name: '投递物品', key: 'garbageName', type: 'text' },
          { name: '投递总量(kg)', key: 'garbageWeight', type: 'custom', minWidth: 120 },
          { name: '单价(元)', key: 'garbagePrice', type: 'custom' },
          { name: '金额价值', key: 'garbageTotalPrice', type: 'custom' },
          { name: '投递方式', key: 'deliveryWay', type: 'custom' },
          { name: '投递柜', key: 'onlineMachine', type: 'text' },
          { name: '交付时间', key: 'createTime', type: 'text', sortable: 'custom', minWidth: 120 },
          { name: '操作人员', key: 'employeesUserName', type: 'text' },
          { name: '社区', key: 'communityName', type: 'text' },
          { name: '货物图片', key: 'garbageImg', type: 'custom' },
          { name: '结算证明', key: 'proveImg', type: 'custom' }],
        formTableButtonsData: [{ name: '查看', key: 'VIEW', action: 'VIEW', className: 'primary', hidden: false, permission: 'VIEW' }],
        formResult: {},
        pageData: { currentPage: 0, pageSize: 20, sortName: '', sortOrder: '' },
        formTableProp: { selection: true, index: true }
      }
    }
  },
  mounted() {
    this.requestcommunityList()
  },
  methods: {
    /*  ------------------------- 按钮相关  -------------------------  */
    onButtonAction(data) {
      if (data && data.item) {
        if (data.item.action === 'VIEW') {
          this.$store.dispatch('setUserDeliveryGarbageDetailData', JSON.parse(JSON.stringify(data.row)))
        }
      }
    },
    /*  ------------------------- 接口请求  -------------------------  */
    requestcommunityList() {
      request({
        url: '/modules/community/communityNoPageList',
        method: 'post'
      }).then(res => {
        if (res.code === '0') {
          for (const item of res.data) {
            item.label = item.name
            item.value = item.id
          }
          this.form.formInputsData[1].data = res.data
        }
      })
    }
  }
}
</script>
